import { Info } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverDescription,
  PopoverHeader,
  PopoverTitle,
  PopoverTrigger,
} from '@/components/ui/popover'
import { Demo, DsSection } from '../primitives'

export function PopoverSection() {
  return (
    <DsSection id="popover" title="Popover">
      <Demo
        label="Info icon trigger — same pattern used on the carrier estimate card's range bar"
        className="flex items-center gap-4"
      >
        <span className="text-muted-foreground text-sm font-medium">Compared to other estimates</span>
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="iconOnly"
              size="icon-sm"
              aria-label="What does this mean?"
              className="text-muted-foreground hover:text-foreground size-4"
            >
              <Info className="size-3.5" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-64 text-sm">
            This bar shows how this estimated price range compares to estimates from other insurance
            providers.
          </PopoverContent>
        </Popover>
      </Demo>

      <Demo label="Structured content — PopoverHeader/PopoverTitle/PopoverDescription">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline">Open popover</Button>
          </PopoverTrigger>
          <PopoverContent>
            <PopoverHeader>
              <PopoverTitle>Notifications</PopoverTitle>
              <PopoverDescription>Choose what you want to be notified about.</PopoverDescription>
            </PopoverHeader>
          </PopoverContent>
        </Popover>
      </Demo>
    </DsSection>
  )
}
